import * as React from 'react'
import { CommonPlaybackAction, PlaybackBlock } from './Headline/PlaybackBlock'
import { DVString, EntitlementCueObject } from '@utils'
import { Offers } from './Headline/Offers'
import * as cn from 'classnames'
import * as styles from './Headline.module.scss'

interface HeadlineProps {
    title?: string
    playbackAction?: CommonPlaybackAction
    offers?: DVString[]
    entitlementCue?: EntitlementCueObject
}

interface HeadlineState extends HeadlineProps {
    transitionStyle?: string
}

export const HeadlineInstance = (props: HeadlineProps) => {
    if (props.playbackAction && props.playbackAction.titleID)
        return (<PlaybackBlock
            playbackAction={{
                ...props.playbackAction,
                label: props.playbackAction.label || props.title
            }} />)
    return <Offers offers={props.offers} entitlementCue={props.entitlementCue}/>
}

export class Headline extends React.PureComponent<HeadlineProps, HeadlineState> {
    constructor(props: HeadlineProps) {
        super(props)
    }

    render() {
        if (this.state && this.state.transitionStyle) {
            const props = this.state.transitionStyle == styles.old ? this.state : this.props
            return (<div className={cn(styles.transitionWrapper, this.state.transitionStyle)}>
                <HeadlineInstance {...props} />
            </div>)
        }
        return <HeadlineInstance {...this.props} />
    }
}